export default (props, traits) => {
  const { rhythm } = traits

  return {
    title: {
      marginBottom: rhythm(0.5)
    }
  }
}
